import * as React from "react";
import moment from "moment";
import { Fragment } from "react";
import BaseListComponent, { IFilterData, BaseListComponentState } from "../../components/BaseListComponent";
import { createFilterData, mapEntityList } from "./../../services/utility/autoMapperService";
import ItemsTable, { filterFieldData } from "../../components/tableComponents/itemsTable";
import TableFilterPane from "./../../components/tableComponents/tableFilterPane";
import sweepRunService from "../../services/sweep/sweepRunService";
import SweepActivitiesDetail from "./sweepActivitiesDetail";

export interface SweepActivitiesProps {}

export interface SweepActivitiesState extends BaseListComponentState {
    data: IFilterData;
    currentPage: number;
    pageSize: number;
    tableItems: any;
    totalSize: number;
    fetchingDetail: boolean;
    filterValueInput: filterFieldData;
    item: any;
}

class SweepActivitiesList extends BaseListComponent<SweepActivitiesState> {}

class SweepActivities extends React.Component<SweepActivitiesProps, SweepActivitiesState> {
    constructor(props: SweepActivitiesProps) {
        super(props);
        this.state = {
            data: createFilterData([]) as IFilterData,
            currentPage: 1,
            pageSize: Number(process.env.REACT_APP_DEFAULT_PAGESIZE) || 10,
            fetching: false,
            fetchingDetail: false,
            tableItems: [],
            totalSize: 0,
            filterValueInput: [],
            item: {},
            showDetailsModal: false,
            showEditModal: false,
            showTableFilterModal: false,
            showTrailModal: false,
        };
    }

    handlePageChange = async (currentPage: number, pageSize:number, data?: IFilterData) => {
        currentPage = currentPage < 0 ? this.state.currentPage : currentPage;
        pageSize = pageSize < 0 ? this.state.pageSize : pageSize;
        this.setState({ fetching: true });
        data = typeof data === "undefined" ? this.state.data : data;
        try {
            const sweepActivities = await sweepRunService.filterSweepActivities(
                data,
                pageSize,
                currentPage
            );
            sweepActivities.data.item2.forEach((element) => {
                element["processing"] = !element["hasError"];
            });
            console.log("inspect: ", sweepActivities.data.item2);
            this.setState({
                tableItems: mapEntityList({
                    entityList: sweepActivities.data.item2,
                    properties: [
                        { oldName: "institutionName", newName: "institutionName" },
                        { oldName: "currentSweepDate", newName: "sweepDate" },
                        { isBoolean: true, oldName: "processing", newName: "processing" },
                        { oldName: "nextStage", newName: "stage" },
                        { oldName: "sweepProcessorCount", newName: "processingLoops" },
                        { oldName: "sweepInitiationType", newName: "sweepInitiationType" },
                        { oldName: "repaymentType", newName: "repaymentType" },
                        { oldName: "transactionCount", newName: "transactionCount" },
                        { oldName: "transactionValue", newName: "transactionValue" },
                    ],
                }),
                currentPage,
                pageSize,
                totalSize: sweepActivities.data.item1,
                fetching: false,
            });
        } catch (ex) {
            // console.log("caught exception", ex);
            if (ex.response && ex.response.status >= 400 && ex.response.status <= 499) {
                // toast.error("Bad Request");
                // console.log(ex.response);
                // errors["response"] = "Internal server error.";
                // console.log(errors);
                // this.setState({ errors, fetching: false });
            } else {
                // toast.error("Internal server error. Please contact the admin.");
                // this.setState({ errors, fetching: false });
            }
        } finally {
            this.setState({ fetching: false });
        }
    };

    // handleOnRetrieveSweepActivities = async () => {
    //     try {
    //         var response = await sweepRunService.retrieveSweepActivities();
    //         this.setState({ sweepActivities: response.data });
    //     } catch (error) {
    //         console.log("error retrieving");
    //     }
    // };

    // async componentDidMount() {
    //     this.handleOnRetrieveSweepActivities();
    //     setInterval(this.handleOnRetrieveSweepActivities, 10000);
    // }

    handleOnExport = async (type: string) => {};

    handleOnResetSweepEpisode = async (item: any) => {
        await sweepRunService.resetSweepEpisode(item.loanAccountInstitution);
        this.handlePageChange(this.state.currentPage, this.state.pageSize);
    };

    fetchItemById = async (item: any) => {
        this.setState({ fetchingDetail: true });
        const sweepConfig = await sweepRunService.retrieveSweepEpisodeActivityInfoById(item.id);
        this.setState({ item: sweepConfig.data, fetchingDetail: false });
    };

    getFilteredItems = (data: IFilterData): IFilterData => {
        let filteredItems: IFilterData = {};
        Object.keys(data).forEach((key) => {
            if (data[key].item2 !== "") {
                filteredItems[key] = data[key];
            }
        });
        return filteredItems;
    };

    async componentDidMount() {
        this.handlePageChange(this.state.currentPage, this.state.pageSize);
    }

    render() {
        const { currentPage, pageSize, tableItems, totalSize, fetching, item, fetchingDetail } = this.state;
        return (
            <Fragment>
                <div className="container-fluid relative animatedParent animateOnce">
                    <div className="animated fadeInUpShort go">
                        <div className="row my-3 mx-2">
                            <h3>
                                <b>Sweep Activities</b>
                            </h3>
                        </div>
                        <SweepActivitiesList
                            pageChangeHandler={this.handlePageChange}
                            fetchingDetail={fetchingDetail}
                            initialValues={{
                                data: createFilterData([]) as IFilterData,
                                fetching: false,
                                showDetailsModal: false,
                                showEditModal: false,
                                showTableFilterModal: false,
                                showTrailModal: false,
                                tableItems: [],
                                filterValueInput: [],
                                item: {},
                            }}
                            tableItems={tableItems}
                            item={item}
                            DetailsModal={({ item, onToggleDetailsModal, showDetailsModal }) => (
                                <Fragment>
                                    <SweepActivitiesDetail
                                        item={item}
                                        showDetailsModal={showDetailsModal}
                                        handleOnResetSweepEpisode={(e) => {
                                            onToggleDetailsModal();
                                            this.handleOnResetSweepEpisode(e);
                                        }}
                                        toggleDetailsModal={onToggleDetailsModal}
                                    />
                                </Fragment>
                            )}
                            ListPayLoad={({
                                data,
                                showTableFilterModal,
                                tableItems,
                                onToggleDetailsModal,
                                onToggleTableFilterModal,
                                onHandleFilterItemRemove,
                                filterValueInput,
                            }) => (
                                <div className="row">
                                    <div className="col-md-12">
                                        <div className="card no-b">
                                            <div className="card-body">
                                                <div className="card-title">
                                                    <div id="list-filters" className="ml-4 mr-4">
                                                        <TableFilterPane
                                                            filteredItems={this.getFilteredItems(data)}
                                                            handleFilterRemove={onHandleFilterItemRemove}
                                                        />
                                                    </div>
                                                    <div id="list-table">
                                                        <ItemsTable
                                                            data={data}
                                                            items={tableItems}
                                                            filterValueInput={filterValueInput}
                                                            showTableFiltermodal={showTableFilterModal}
                                                            toggleTableFiltermodal={onToggleTableFilterModal}
                                                            name="Sweep Activities"
                                                            currentPage={currentPage}
                                                            pageSize={pageSize}
                                                            totalSize={totalSize}
                                                            fetching={fetching}
                                                            handlePageChange={this.handlePageChange}
                                                            onViewDetails={(item: any) => {
                                                                this.fetchItemById(item);
                                                                onToggleDetailsModal();
                                                            }}
                                                            handleOnExport={this.handleOnExport}
                                                            amountColumn={["transactionValue"]}
                                                            timeColumn={["currentSweepDate"]}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )}
                        ></SweepActivitiesList>
                    </div>
                </div>
            </Fragment>
        );
    }
}

export default SweepActivities;
